import { render, staticRenderFns } from "./ForgotPw_otp_done.vue?vue&type=template&id=f4209ef2&scoped=true&"
import script from "./ForgotPw_otp_done.vue?vue&type=script&lang=js&"
export * from "./ForgotPw_otp_done.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPw_otp_done.vue?vue&type=style&index=0&id=f4209ef2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4209ef2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
